import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import { useCrmEnrichmentJobRemoveMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobRemoveMutation";

import { hubspotEnrichmentQueryKeys } from "../queries/queryKeyFactory";
import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

export default function useHsEnrichmentJobRemoveMutation() {
    const dispatch = useDispatch();

    return useCrmEnrichmentJobRemoveMutation({
        apiService: hubspotEnrichmentAPIService,
        queryKeys: hubspotEnrichmentQueryKeys,
        onSuccessCallback: (_, job) => {
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text: translate("si.crm-enrichment.hs.remove-modal.success.toast.named", {
                            jobName: job.name,
                        }),
                    }),
                ),
            );
        },
    });
}
